import { useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'
import { DateTimeInput, SelectInput, TextField, TextInput } from 'react-admin'
import { ImportProperties } from '../../../core/enum/ImportProperties'
import { TicketType } from '../../../core/enum/TicketType'
import { BookingType } from '../../../core/enum/BookingType'
import FilteredReferenceInput from '../../common/FilteredReferenceInput'
import { ResourceName } from '../../../core/ResourceName'
import { Authority } from '../../../core/auth/Authority'
import { useHasAuthority } from '../../hooks/useHasAuthority'
import { BookingDisabledOption } from '../../../core/enum/BookingDisabledOption'
import { dateTimeInputDefaultParse } from '../../../core/common/date-time'

const MappingFilteredReferenceInput = (props) => {
  const { authority, reference, ...rest } = props
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const hasAuthority = useHasAuthority()

  return hasAuthority(authority) ? (
    <FilteredReferenceInput
      {...rest}
      source="staticValue"
      reference={reference}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={smallScreen ? 5 : 15}
      filterSource="name"
      selectWithPaginationInputProps={{
        optionText: 'name',
        showFilter: true,
        options: {
          resettable: true,
        },
      }}
      fullWidth
    />
  ) : (
    <TextField {...rest} source="staticValue" />
  )
}

const MappingSelectInput = (props) => {
  const { objectType, objectTypeName, ...rest } = props

  return (
    <SelectInput
      {...rest}
      source="staticValue"
      choices={Object.entries(objectType).map(([value]) => ({
        id: value,
        name: `resources.enums.${objectTypeName}.${value}`,
      }))}
      fullWidth
      resettable
    />
  )
}

export const MappingStaticValueInput = ({ ...props }) => {
  const { property, ...rest } = props

  switch (property) {
    case ImportProperties.TICKET_TYPE:
      return (
        <MappingSelectInput
          {...rest}
          objectType={TicketType}
          objectTypeName="ticketType"
        />
      )
    case ImportProperties.BOOKING_TYPE:
      return (
        <MappingSelectInput
          {...rest}
          objectType={BookingType}
          objectTypeName="bookingType"
        />
      )
    case ImportProperties.DISABLED:
      return (
        <MappingSelectInput
          {...rest}
          objectType={BookingDisabledOption}
          objectTypeName="bookingDisabled"
        />
      )
    case ImportProperties.SEAT_ID:
      return <></>
    case ImportProperties.BLOCK_ID:
      return (
        <MappingFilteredReferenceInput
          {...rest}
          authority={Authority.VIEW_BLOCKS}
          reference={ResourceName.BLOCKS}
        />
      )
    case ImportProperties.VARIANT_ID:
      return (
        <MappingFilteredReferenceInput
          {...rest}
          authority={Authority.VIEW_VARIANTS}
          reference={ResourceName.VARIANTS}
        />
      )
    case ImportProperties.EVENT_ID:
      return (
        <MappingFilteredReferenceInput
          {...rest}
          authority={Authority.VIEW_EVENTS}
          reference={ResourceName.EVENTS}
        />
      )
    case ImportProperties.BOOKING_ACTIVE_FROM:
    case ImportProperties.BOOKING_ACTIVE_TO:
      return (
        <DateTimeInput
          {...rest}
          parse={dateTimeInputDefaultParse}
          source="staticValue"
          fullWidth
        />
      )
    default:
      return <TextInput {...rest} source="staticValue" />
  }
}
